import { useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input, Space } from 'antd';
import {
    BUTTON_ACTION_TYPE,
    ButtonFilterAction,
} from '@app/components/UI/Button';
import useInvoiceFormPageStore from '../hooks/usePageStore';

const InvoiceFormFilter = () => {
    const { filterParams, setFilterParams } = useInvoiceFormPageStore();

    const [searchText, setSearchText] = useState(filterParams.keyword);

    const onSearch = () => {
        setFilterParams({ keyword: searchText, currentPage: 1 });
    };

    const onChangeKeyword = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
    };

    return (
        <div className="row">
            <div className="col-md-6 col-xs-8">
                <div className="form-group filter-group">
                    <Space.Compact style={{ width: '100%' }}>
                        <Input
                            style={{ width: '80px', flexShrink: 0 }}
                            defaultValue="Tìm kiếm"
                            disabled
                        />
                        <Input
                            value={searchText}
                            onChange={onChangeKeyword}
                            onPressEnter={onSearch}
                            placeholder="Nhập từ khóa tìm kiếm..."
                            prefix={<SearchOutlined />}
                            allowClear
                        />
                    </Space.Compact>
                </div>
            </div>

            <div className="col-md-3 col-xs-4">
                <div className="form-group">
                    <div className="no-margin">
                        <div className="btn-group">
                            <ButtonFilterAction
                                labelButton="Tìm kiếm"
                                buttonType={BUTTON_ACTION_TYPE.SEARCH}
                                onClick={onSearch}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceFormFilter;
